import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import node, {
  type teamsTeamSettingsPageQuery,
} from '#gen/relay/teamsTeamSettingsPageQuery.graphql'

export const Route = createFileRoute(
  '/_dashboard/$account/settings/teams/$team/_team/settings',
)({
  staticData: { title: 'Team Settings' },
  loader({ context, params }) {
    return context.preload<teamsTeamSettingsPageQuery>(node, params)
  },
  component: lazyRouteComponent(
    () =>
      import('#app/pages/account/teams/teams-page/teams-team-settings-page'),
    'TeamsTeamSettingsPage',
  ),
})
